
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"fill":"#353A48","width":"28","height":"20","rx":"2"}}),_c('path',{attrs:{"d":"M14.147 5.898a5.39 5.39 0 00-3.536-1.319c-3.012 0-5.453 2.473-5.453 5.523s2.441 5.522 5.453 5.522a5.39 5.39 0 003.536-1.32 5.39 5.39 0 003.537 1.32c3.012 0 5.453-2.473 5.453-5.522 0-3.05-2.441-5.523-5.453-5.523a5.39 5.39 0 00-3.537 1.32z","fill":"#FF5E00"}}),_c('path',{attrs:{"d":"M14.147 5.898a5.39 5.39 0 00-3.536-1.319c-3.012 0-5.453 2.473-5.453 5.523s2.441 5.522 5.453 5.522a5.39 5.39 0 003.536-1.32 5.54 5.54 0 01-1.915-4.202 5.54 5.54 0 011.915-4.204z","fill":"#ED0006"}}),_c('path',{attrs:{"d":"M14.147 14.305a5.39 5.39 0 003.537 1.319c3.012 0 5.453-2.473 5.453-5.522 0-3.05-2.441-5.523-5.453-5.523a5.39 5.39 0 00-3.537 1.32 5.54 5.54 0 011.916 4.203 5.54 5.54 0 01-1.916 4.203z","fill":"#F9A000"}})])])
          )
        }
      }
    